import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { AuthStatusCode, RoutePathname } from '@as-react/common-types';
import { getHomepageUrl } from '@as-react/common-utils';
import * as Icons from '@yonderland/andes-icons';
import { Box, Grid, LinkButton, StackInline } from '@yonderland/andes-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { EmailRecognitionForm } from '../../components/checkout/login/forms/EmailRecognitionForm';
import { ForgotPasswordForm } from '../../components/checkout/login/forms/ForgotPasswordForm';
import { LoginForm } from '../../components/checkout/login/forms/LoginForm';
import { RegistrationForm } from '../../components/checkout/login/forms/RegistrationForm';
import { SetPasswordForm } from '../../components/checkout/login/forms/SetPasswordForm';
import { ShoplandingLogin } from '../../components/checkout/login/shoplanding/ShoplandingLogin';
import { PersonalDetails } from '../../components/checkout/personal-details/PersonalDetails';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { CheckoutStep } from '../../context/CheckoutStepContext';
import { useOAuth } from '../../hooks/useOAuth';
import { analyticsActions } from '../../redux/analytics/actions/AnalyticsActions.creators';
import { authActions } from '../../redux/authentication/actions/AuthActions.creators';
import { basketActions } from '../../redux/basket/actions/BasketActions.creators';
import checkoutActions from '../../redux/checkout/actions/CheckoutActions.creators';
import { generatePathUrl } from '../../util/URLParamUtil';
import { CheckoutLayoutContainer } from './CheckoutLayoutContainer';
var Steps;
(function (Steps) {
    Steps[Steps["EMAIL_RECOGNITION"] = 0] = "EMAIL_RECOGNITION";
    Steps[Steps["LOGIN"] = 1] = "LOGIN";
    Steps[Steps["REGISTER"] = 2] = "REGISTER";
    Steps[Steps["PASSWORD_FORGOTTEN"] = 3] = "PASSWORD_FORGOTTEN";
    Steps[Steps["PERSONAL_DETAILS"] = 4] = "PERSONAL_DETAILS";
    Steps[Steps["SET_PASSWORD"] = 5] = "SET_PASSWORD";
})(Steps || (Steps = {}));
export const LoginLayout = ({ children }) => (_jsx(Box, { marginInline: { xs: '5' }, children: _jsx(StackInline, { contentAlign: "center", children: _jsx("div", { style: { maxWidth: '1336px', flex: 1 }, children: _jsx(Grid, { columns: 12, gapX: 2, children: _jsx(Grid.Cell, { span: { xs: 12, md: 8, lg: 6 }, offset: { md: 3, lg: 4 }, children: _jsx(Box, { paddingBlockStart: { xs: '14', md: '12' }, paddingBlockEnd: "20", children: children }) }) }) }) }) }));
export const CheckoutLoginContainer = () => {
    const { isShopLanding, root, isInAuthorMode, basketOverviewUrl } = useAemConfig();
    const { t } = useTranslation(I18N_NAMESPACES.checkout);
    const [step, setStep] = useState(Steps.EMAIL_RECOGNITION);
    const history = useHistory();
    const dispatch = useDispatch();
    const { isLoggedIn } = useOAuth();
    const handleBackClick = () => {
        switch (step) {
            case Steps.EMAIL_RECOGNITION:
            case Steps.LOGIN:
                window.location.href = basketOverviewUrl;
                break;
            case Steps.REGISTER:
            case Steps.SET_PASSWORD:
                setStep(Steps.EMAIL_RECOGNITION);
                break;
            case Steps.PASSWORD_FORGOTTEN:
                setStep(Steps.LOGIN);
                break;
            default:
                window.location.href = getHomepageUrl(root);
                break;
        }
    };
    const handleEmailRecognitionFinish = (existsResponse) => {
        if (existsResponse &&
            [
                AuthStatusCode.VALID_ACCOUNT_OTHER_FASCIA,
                AuthStatusCode.INVALID_ACCOUNT_OTHER_FASCIA,
                AuthStatusCode.INVALID_ACCOUNT,
            ].includes(existsResponse.accountStatusCode)) {
            setStep(Steps.SET_PASSWORD);
        }
        else if (existsResponse === null || existsResponse === void 0 ? void 0 : existsResponse.hasIdentity) {
            setStep(Steps.LOGIN);
        }
        else {
            setStep(Steps.REGISTER);
        }
    };
    const handleForgotPasswordClick = () => setStep(Steps.PASSWORD_FORGOTTEN);
    const handleRegistrationSubmit = () => setStep(Steps.PERSONAL_DETAILS);
    const handleEditEmailClick = () => setStep(Steps.EMAIL_RECOGNITION);
    useEffect(() => {
        dispatch(basketActions.createGetAction());
        dispatch(authActions.createInitSocialAction());
        dispatch(analyticsActions.checkoutStep({ step: 2 }));
        dispatch(checkoutActions.createLoginAnalyticsAction());
        dispatch(checkoutActions.createSetHasRegistrationAction(false));
    }, []);
    useEffect(() => {
        if (isLoggedIn) {
            history.replace(generatePathUrl(root, `buy.html/${RoutePathname.DELIVERY}`, isInAuthorMode));
        }
    }, [isLoggedIn]);
    if (isShopLanding) {
        return (_jsx(LoginLayout, { children: _jsx(ShoplandingLogin, {}) }));
    }
    if (step === Steps.PERSONAL_DETAILS) {
        return (_jsx(CheckoutLayoutContainer, { step: CheckoutStep.DETAILS, children: _jsx(PersonalDetails, {}) }));
    }
    return (_jsx(LoginLayout, { children: _jsxs(Box, { children: [_jsx(Box, { paddingBlockEnd: "10", children: _jsx(LinkButton, { onClick: handleBackClick, theme: "branded", text: t('checkout.back'), iconLeft: { source: Icons.ArrowLeftIcon, size: 'sm' }, testId: "checkout-login-back-button" }) }), step === Steps.EMAIL_RECOGNITION && _jsx(EmailRecognitionForm, { onFinish: handleEmailRecognitionFinish }), step === Steps.LOGIN && (_jsx(LoginForm, { onEditEmailClick: handleEditEmailClick, onForgotPasswordClick: handleForgotPasswordClick })), step === Steps.REGISTER && (_jsx(RegistrationForm, { onEditEmailClick: handleEditEmailClick, onSubmit: handleRegistrationSubmit })), step === Steps.PASSWORD_FORGOTTEN && _jsx(ForgotPasswordForm, { onBackButtonClick: handleBackClick }), step === Steps.SET_PASSWORD && _jsx(SetPasswordForm, { onEditEmailClick: handleEditEmailClick })] }) }));
};
